import * as React from "react";
import { Col } from "./../Col";
import * as CMP from "sb-resp-ui";
export class BetBtn extends React.Component {
    render() {
        return (React.createElement(Col, { modifier: "rj-racing-next-races__col--odds" },
            React.createElement(CMP.BetBtn, { modifier: this.props.modifier, type: CMP.BetBtnTypes.Odd, handler: this.props.handler, odd: this.props.odds, isDisabled: this.props.isDisabled, dataUat: "button-next-races-odds-selection" })));
    }
}
//# sourceMappingURL=BetBtn.js.map